import { NJBadge, NJLink } from '@engie-group/fluid-design-system-react';

import styles from './NJSelectedEquipmentBanner.module.css';
import { AssistantId } from '@genai/assistant';
import { useNavigate } from 'react-router-dom';

export type ISelectedEquipmentBannerProps = {
  assistantId: AssistantId;
  brand: string;
  model: string;
}

export const NJSelectedEquipmentBanner = function({ assistantId, brand, model }: ISelectedEquipmentBannerProps) {
  const navigate = useNavigate();

  const onLinkClick = () => {
    navigate(`/assistant/${assistantId}/chat`);
  };

  return (
    <div className={styles['nj-chat-equipment-select']}>
      <div className={styles['nj-chat-equipment-select__badges']}>
        <NJBadge
          scale="lg"
          isUppercase
          emphasis="minimal"
          variant="discovery"
          className={styles['nj-chat-equipment-select__badge']}
        >
          {brand}
        </NJBadge>

        <NJBadge
          scale="lg"
          isUppercase
          emphasis="minimal"
          variant="discovery"
          className={styles['nj-chat-equipment-select__badge']}
        >
          {model}
        </NJBadge>
      </div>

      <p className={styles['nj-chat-equipment-select__text']}>
        <span className={styles['nj-chat-equipment-select__bold']}>
          La conversation porte sur l'équipement {brand} - {model}.
        </span>

        &nbsp;&nbsp;
        <NJLink onClick={onLinkClick}>
          Cliquez ici
        </NJLink>
        &nbsp;
        pour en changer.
      </p>
    </div>
  );
};
